import React, { Component } from "react";
import styled from "styled-components";
import {
  GridContent,
  SectionTitle,
  InnerContent,
} from "../../../pages/Ems/Main";

class PowerSystem extends Component {
  // constructor(props) {}

  render() {
    return (
      <GridContent>
        <SectionTitle>전력 계통 상황</SectionTitle>
        <InnerContent
          style={{ height: "calc(100% - 30px)", position: "relative" }}
        >
          <SystemContent>
            <DeviceList>
              <p className="device-name">태양광</p>
              <p className="device-name">전력 기기</p>
              <p className="device-name">블루배터리</p>
            </DeviceList>
            <img
              className="arrow-obj"
              src="images/ctors/ems/arrow-right.png"
              alt=""
            />

            <ImageWrap>
              <img
                className="retangle-obj"
                src="images/ctors/ems/rectangle-obj.png"
                alt=""
              />
            </ImageWrap>
            <RelationShipBox>
              <ul>
                <li>공급</li>
                <li>75%</li>
              </ul>
              <ul>
                <li>수요</li>
                <li>75%</li>
              </ul>
              <ul className="operating">
                <li>운용률</li>
                <li>75%</li>
              </ul>
              <ul>
                <li>공급</li>
                <li>75%</li>
              </ul>
            </RelationShipBox>
            <CommonBox>
              <dl>
                <dt>PV 사용전력</dt>
                <dd>1.5 kW</dd>
              </dl>
              <dl>
                <dt>ESS 사용전력</dt>
                <dd>0.5 kW</dd>
              </dl>
              <dl>
                <dt>Charging</dt>
                <dd>
                  <span>time</span>
                  <span>00 min</span>
                </dd>
                <dd>
                  <span>전압</span>
                  <span>00 min</span>
                </dd>
                <dd>
                  <span>전류</span>
                  <span>00 A</span>
                </dd>
              </dl>
              <dl>
                <dt>Discharging</dt>
                <dd>
                  <span>time</span>
                  <span>00 min</span>
                </dd>
                <dd>
                  <span>전압</span>
                  <span>00 min</span>
                </dd>
                <dd>
                  <span>전류</span>
                  <span>00 A</span>
                </dd>
              </dl>
            </CommonBox>
          </SystemContent>
        </InnerContent>
      </GridContent>
    );
  }
}

const SystemContent = styled.div`
  width: 100%;
  height: 100%;
  img {
    position: absolute;
  }
  .arrow-obj {
    width: 28px;
    height: 12px;
    object-fit: contain;
    top: 25%;
    left: 13%;
  }
`;
const RelationShipBox = styled.div`
  ul {
    position: absolute;
    height: 23px;
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    border: 1px solid #2f3191;
    border-radius: 5px;
    z-index: 2;
    &:nth-child(1) {
      width: 100px;
      top: 60%;
      left: 2%;
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      width: 80px;
    }
    &:nth-child(2) {
      top: 40%;
      left: 55%;
      transform: translateX(-50%);
    }
    &:nth-child(3),
    &:nth-child(4) {
      bottom: 10%;
    }
    &:nth-child(3) {
      left: 40%;
    }
    &:nth-child(4) {
      right: 40%;
    }
  }
  li {
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    text-align: center;
    &:first-child {
      width: 32px;
      font-size: 12px;
      background-color: #d8d9fd;
      border-radius: 5px 0 0 5px;
      line-height: 1.7;
    }
    &:last-child {
      width: calc(100% - 32px);
      font-size: 15px;
      font-weight: bold;
      color: #494949;
      background-color: #fff;
      border-radius: 0 5px 5px 0;
      line-height: 1.4;
    }
  }
  .operating {
    li:first-child {
      width: 40px;
    }
    li:last-child {
      width: calc(100% - 40px);
    }
  }
`;
const DeviceList = styled.div`
  p {
    position: absolute;
    font-size: 14px;
    color: #fff;
    background-color: #2f3191;
    width: 100px;
    padding: 6px 0;
    border-radius: 10px;
    text-align: center;
    font-weight: bold;
    &:nth-child(1) {
      top: 22%;
      left: 2%;
    }
    &:nth-child(2) {
      top: 21%;
      left: 45%;
      transform: translateY(-50%);
    }
    &:nth-child(3) {
      bottom: 25%;
      left: 45%;
      transform: translateY(-50%);
    }
  }
`;
const ImageWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 715px;
  height: 143px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const CommonBox = styled.div`
  dl {
    position: absolute;
    border: 1px solid #2f3191;
    border-radius: 5px;
    &:nth-child(1),
    &:nth-child(2) {
      width: 90px;
      top: 20%;
      text-align: center;
    }
    &:nth-child(1) {
      left: 27%;
    }
    &:nth-child(2) {
      right: 27%;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 130px;
      bottom: 5%;
      dd {
        display: grid;
        grid-template-columns: 1fr 2fr;
      }
    }
    &:nth-child(3) {
      left: 25%;
    }
    &:nth-child(4) {
      right: 25%;
    }
  }
  dt {
    text-align: center;
    border-radius: 5px 5px 0 0;
    background-color: #d8d9fd;
    font-size: 12px;
    padding: 5px 0;
  }
  dd {
    font-size: 16px;
    color: #494949;
    background-color: #fff;
    border-radius: 0 0 5px 5px;
    padding: 4px 0;
    span {
      &:first-child::after {
        content: "|";
      }
      &:last-child {
        text-align: right;
      }
    }
  }
`;
export default PowerSystem;
